export default "__VITE_ASSET__Um9NG799__"